import styled, { css } from 'styled-components';

import { Button } from 'libs/ui';

export const StyledButton = styled(Button)`
  position: absolute;
  right: 20px;
  bottom: 20px;
  &.saving{
    &:after{
      content: '';
      border-radius: 40px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, .9) url('/images/loader.gif') no-repeat 50% 50%;
      background-size: auto 70% ;
    }
  }
`;
export const Zone = styled.div`
  background-color: ${(props) => props.color};
  //height: 650px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  /* v2: the panel body is a CP surface (light: white, dark: dark) instead of the
     raw zone colour — the zone identity stays on the coloured tabs. This removes
     the "white chunk" that appeared when the popup no longer forces a dark
     background, and keeps the rack labels (var(--cp-text)) readable in both
     themes. */
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      background-color: var(--cp-surface);
    `}
`;
export const CheckboxWrapper = styled.div`
  margin-bottom: 20px;
`;
export const Checkbox = styled.span`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-right: 10px;
  &.checkbox {
    input {
      margin-right: 5px;
      appearance: none;
      outline: none;
      cursor: pointer;
      width: 14px;
      height: 14px;
      border-radius: 4px;
      border: 1px solid var(--cp-text-tertiary, #fff);
      opacity: 1;
      &:checked {
        background-size: cover;
        background-repeat: no-repeat;
        background-color: var(--cp-accent, #fff);
        border: none;
      }
    }
    label {
      font-size: 15px;
      color: var(--cp-text, #fff);
      opacity: 1;
    }
  }
`;
